// TODO: Platform/global configuration value to be shared between runtime and build scripts.
export const INTERMEDIATE_ASSETS_SCALE = require("../../../tool/Assets/constants").INTERMEDIATE_ASSETS_SCALE;
